/**
 * Paginacao no servidor (spec 058, Fase 2): `?pagina=N&por_pagina=20`, resposta `{ itens, total, pagina, paginas }`, o
 * mesmo formato que Vendas antigas ja usa. O total e do filtro inteiro, contado no banco, entao os numeros de cima da
 * tela nao mudam com a pagina. Mora aqui (e nao em cada servico) pra backend e pagamentos paginarem igual.
 */
import { z } from "zod";
export const POR_PAGINA = 20;
/** Os dois campos da querystring. Sem `pagina`, a rota segue como era (com `limite`), pra quem ja chamava assim. */
export const QueryDePagina = { pagina: z.coerce.number().int().min(1).optional(), por_pagina: z.coerce.number().int().min(1).max(100).default(POR_PAGINA) };
/** A pagina pedida dentro do que existe: depois de um filtro que encolhe a lista, a pagina 7 vira a ultima. */
export function fatiar(total, pagina, porPagina) {
    const paginas = Math.max(1, Math.ceil(total / porPagina));
    const atual = Math.min(Math.max(1, pagina), paginas);
    return { pagina: atual, paginas, pular: (atual - 1) * porPagina };
}
//# sourceMappingURL=paginacao.js.map